import React, { useState, useEffect, useRef } from 'react'
import { apiProcess } from '../../api/api.js'
import { auth } from 'components/auth/auth.js'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import { Subscribe } from 'unstated'
import { timeOptions, MAPBOX_API_KEY } from '../../../constants'
import AppContainer from '../../context/AppContainer'
import { convertCents } from '../../utils'
import PricingSummary from '../../pricing/summary/pricingSummary'
import 'react-dates/initialize'
import { Button, Columns, Modal } from '../../elements/index'
import { Field } from 'components/elements'
import 'react-dates/lib/css/_datepicker.css'
import { SingleDatePicker } from 'react-dates'
import { withRouter } from 'react-router-dom'
import { withGetPricing } from '../../pricing/pricing.js'
import { compose } from 'recompose'
import RatingStars from '../../elements/ratingStars'
import getSymbolFromCurrency from 'currency-symbol-map'
import NumberFormat from 'react-number-format'
import MobileDatesSelector from '../../elements/dateSelector/mobileDatesSelector'
import MapboxAutocomplete from '../../theme/mapboxSearchAutoComplete/ReactMapboxAutocomplete'
import {
  paymentModuleContents,
  isDayClosed,
  formatDatesForAPI,
} from './paymentModuleUtil.js'
import isBeforeDay from '../../elements/dateSelector/airbnbUtils/isBeforeDay'
import isSameDay from '../../elements/dateSelector/airbnbUtils/isSameDay'
import {
  removeFromUrlPush,
  addToUrlPush,
} from '../../search/filters/filterUtil.js'
import DotsLoaderDark from '../../theme/assets/images/loaders/three-dots-dark.svg'
import './paymentModule.css'
import {
  trackBookNowSuccessAttempt,
  trackBookNowFailedAttempt,
} from '../../elements/tracking/bikeProfileTracking.js'
import { trackProceedToCheckoutError, trackProceedToCheckoutSuccess } from './../../elements/klaviyoTracking/proceedToCheckout'
import { createReservationTimeStamp } from './../../payments/booking/paymentUtils.js'
import { Formik } from 'formik'
import BikeProfilePaymentModuleHeader from './bikeProfilePaymentModuleHeader'
import BookingCalendarTabs from './bookingCalendarTabs'
import { prepStartAndEndTimeForBackend } from '../../payments/booking/paymentUtils.js'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Grid from '@mui/material/Grid'
import { multiDayPricingList } from 'components/utils/multiDayPricingList.js'
import {
  findPriceForLoggedInUser,
  findPriceForNonLoggedInUser,
  canShowCrossedDailyRentalPrice
} from '../../../components/search/layout/searchUtil.js'
import Cookies from 'js-cookie'
import BirthDateModal from './birthDateModal.js'
import RentalDurationError from './rentalDurationError.js'

let classNames = require('classnames')

const MotorcycleBookingWCalendarPanel = (props) => {
  // This is needed to call the childs autocomplete clearAutocompleteValue()
  const { bikeRentalDays } = props.bikeData
  const childRef = useRef(null)
  const inputRef = useRef()
  const minRentalDays = bikeRentalDays.min ? bikeRentalDays.min : null
  const maxRentalDays = bikeRentalDays.max ? bikeRentalDays.max : null
  const minRentalHours = minRentalDays ? minRentalDays * 24 : null
  const maxRentalHours = maxRentalDays ? maxRentalDays * 24 : null

  const [processingError, setProcessingError] = useState(false)
  const [processingErrorMessage, setProcessingErrorMessage] = useState('')
  const [bookLoading, setBookLoading] = useState(false)
  const [startDate, setStartDate] = useState(
    props.startDate ? moment(props.startDate) : null
  )
  const [endDate, setEndDate] = useState(
    props.endDate ? moment(props.endDate) : null
  )
  const [singleStartDate, setSingleStartDate] = useState(
    props.startDate ? moment(props.startDate) : null
  )
  const [singleEndDate, setSingleEndDate] = useState(
    props.endDate ? moment(props.endDate) : null
  )
  const [startDateFocus, setStartDateFocus] = useState(null)
  const [endDateFocus, setEndDateFocus] = useState(null)
  const [focusedInput, setFocusedInput] = useState(null)
  const [blackOutDates, setBlackOutDates] = useState(props.blackOutDates)
  const [mobileOpenState, setMobileOpenState] = useState(false)
  // const [priceSummary, setPriceSummary] = useState({})
  const [summaryLoading, setSummaryLoading] = useState(false)
  const [openMobileDates, setOpenMobileDates] = useState(false)
  const [datesError, setDatesError] = useState(false)
  const [dateWarningReady, setDateWarningReady] = useState(false)
  const [displayTimeError, setDisplayTimeError] = useState(false)
  const [displayDateError, setDisplayDateError] = useState(false)
  const [rentalDurationError, setRentalDurationError] = useState(null)
  const [motorcycleData, setMotorcycleData] = useState(null)
  const [sameDayRental, setSameDayRental] = useState(false)
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  // DELIVERY STATE VARIABLES
  const [expanded, setExpanded] = useState(false)
  const [deliveryAddress, setDeliveryAddress] = useState(null)
  const [deliveryAddressObject, setDeliveryAddressObject] = useState(null)
  const [deliverySelected, setDeliverySelected] = useState(false)
  const [deliveryPrice, setDeliveryPrice] = useState(null)
  const [deliveryApplied, setDeliveryApplied] = useState(false)
  const [isCalculating, setIsCalculating] = useState(false)
  const [deliveryLat, setDeliveryLat] = useState(null)
  const [deliveryLong, setDeliveryLong] = useState(null)
  const [unableToDeliverError, setUnableToDeliverError] = useState(false)
  const [applyingDeliveryFee, setApplyingDeliveryFee] = useState(false)
  const [cancelingDelivery, setCancelingDelivery] = useState(false)
  const [deliveryApplyClicked, setDeliveryApplyClicked] = useState(false)
  const [userBirthDate, setUserBirthDate] = useState(null)
  const [openBirthDateModal, setOpenBirthDateModal] = useState(false)

  const timezone = props.timezone
  const bikeData = props.bikeData
  const desktopOrMobile = props.desktopOrMobile
  const multidayDiscountApplied = props.multidayDiscountApplied
  const baseRentalPriceCents = props.baseRentalPriceCents
  const baseRentalPriceCurrency = props.baseRentalPriceCurrency

  const isAuthenticated = auth.isAuthenticated()
  const isTripTaken = Number(auth.userRideTakenCount()) > 0 ? true : false
  let multiDayPricingLists = multiDayPricingList(
    bikeData.bike_info.multi_day_pricing.length > 0 ?
    bikeData.bike_info.multi_day_pricing
      : null
  )

  const bookNowBox = datesError ? 'book-now-box dates-error' : 'book-now-box'
  const showDateWarning =
    dateWarningReady && !startDate && !endDate && bikeData.has_multiday_discount

  const dateWarningClasses = `has-tooltip-bottom has-tooltip-active has-tooltip-danger has-tooltip-arrow has-multiline-tooltip danger-border`
  const tooltipClass = classNames({
    [dateWarningClasses]: showDateWarning,
  })

  const tooltipProps = {
    className: tooltipClass,
  }
  if (showDateWarning) {
    tooltipProps['data-tooltip'] = 'Enter Dates for most accurate pricing'
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    setUserBirthDate(Cookies.get('userBirthDate'))
    setSummaryLoading(true)
    if (props.desktopOrMobile === 'mobile') {
      document.body.classList.add('has-fixed-cta')
    }
    if (startDate && endDate) {
      if (!checkClosedDays(startDate, endDate)) {
        let startDateMoment = moment(startDate, 'YYYY-MM-DD', true)
        let endDateMoment = moment(endDate, 'YYYY-MM-DD', true)
        setStartDate(startDateMoment)
        setEndDate(endDateMoment)
        calculateDaysTotal(startDateMoment, endDateMoment)
      } else {
        //if we have bad dates
        setProcessingError(true)
        setProcessingErrorMessage(
          <>
            <i className="fal fa-exclamation-circle"></i> This bike is not
            available for the dates you selected. Please select alternative
            dates, or return to search to find a different motorcycle.
          </>
        )
      }
    } else {
      setSummaryLoading(false)
    }
    setTimeout(() => {
      setDateWarningReady(true)
    }, 500)

    loadHoursOfAvailability()
  }, [])

  const loadHoursOfAvailability = () => {
    if (props.bikeID) {
      let apiURL = 'motorcycles/' + props.bikeID
      if (
        props.bikeData.bike_state === 'protected' &&
        props.bikeData.bike_dealer_access_restriction
      ) {
        apiURL +=
          '?dealer_access_token=' + props.bikeData.bike_dealer_access_token
      }
      apiProcess(
        apiURL,
        false,
        'get-hours-of-availablity',
        'Get hours of availability for a particular bike.'
      )
        .then(function (responseData) {
          setMotorcycleData(responseData?.motorcycle || {})
        })
        .catch()
    }
  }

  const onFocusChange = (focusedInput) => {
    setFocusedInput(!focusedInput ? 'startDate' : focusedInput)
  }

  const handleSingleDateChange = (start, end) => {
    let queryValuesToAdd = []
    if (start) {
      setStartDate(start)
      setProcessingError(false)
      setDatesError(false)
      setOpenMobileDates(false)
      queryValuesToAdd.push({
        key: 'startDate',
        value: moment(start).format('YYYY-MM-DD'),
      })
    }
    if (end) {
      setEndDate(end)
      setProcessingError(false)
      setDatesError(false)
      setOpenMobileDates(false)
      queryValuesToAdd.push({
        key: 'endDate',
        value: moment(end).format('YYYY-MM-DD'),
      })
    }

    let newQueryString = addToUrlPush(queryValuesToAdd, props.location.search)

    props.history.push('?' + newQueryString.string)

    props.onDateChange(start, end)
    if (start !== null && end !== null) {
      setStartDateFocus(null)
      setEndDateFocus(null)
    }
  }

  const handleDateChange = (start, end) => {
    let queryValuesToAdd = []
    if (start) {
      setStartDate(start)
      setProcessingError(false)
      setDatesError(false)
      setOpenMobileDates(false)
      queryValuesToAdd.push({
        key: 'startDate',
        value: moment(start).format('YYYY-MM-DD'),
      })
    }
    if (end) {
      setEndDate(end)
      setProcessingError(false)
      setDatesError(false)
      setOpenMobileDates(false)
      queryValuesToAdd.push({
        key: 'endDate',
        value: moment(end).format('YYYY-MM-DD'),
      })
    }

    let newQueryString = addToUrlPush(queryValuesToAdd, props.location.search)

    props.history.push('?' + newQueryString.string)

    props.onDateChange(start, end)
    if (start !== null && end !== null) {
      setFocusedInput(null)
    }
  }

  const onClearDates = () => {
    setStartDate(null)
    setEndDate(null)
    setFocusedInput('startDate')
    setDatesError(false)
    setProcessingError(false)
    setProcessingErrorMessage(null)

    let newQueryString = removeFromUrlPush(
      ['startDate', 'endDate'],
      props.location.search
    )

    props.history.push('?' + newQueryString.string)

    props.resetPricing()
    props.onClearDates()
  }

  const checkClosedDays = (startDate, endDate) => {
    let startDateTest = isDayClosed(moment(startDate), props.closedDays)
    let endDateTest = isDayClosed(moment(endDate), props.closedDays)

    if (startDateTest || endDateTest) {
      return true
    }

    return false
  }

  const getPrcingOptions = () => {
    const tempBirthDate = Cookies.get('userBirthDate')
    return {
      birthdate: tempBirthDate,
      delivery_location: {
        longitude: deliveryLong,
        latitude: deliveryLat,
        formatted_address: deliveryAddressObject.formatted_address,
        full_address: deliveryAddressObject.full_address,
      },
    }
  }

  const bookReservation = () => {
    setBookLoading(true)
    const birthDate = Cookies.get('userBirthDate')

    const apiURL = 'riders/requests'

    const currentUrl = window.location.href

    const bookingData = {
      motorcycle_pretty_id: props.bikeID.toUpperCase(),
      start_at: createReservationTimeStamp(
        moment
          .tz(startDate.startOf('day').format('YYYY-MM-DD'), props.timezone)
          .utc(),
        startTime,
        timezone
      ),
      end_at: createReservationTimeStamp(
        moment
          .tz(endDate.startOf('day').format('YYYY-MM-DD'), props.timezone)
          .utc(),
        endTime,
        timezone
      ),
      pricing_options: deliveryAddressObject ? getPrcingOptions() : { birthdate: birthDate },
    }

    apiProcess(
      apiURL,
      bookingData,
      'create-reservation',
      props.processingDescription
    )
      .then(function (responseData) {
        let resID = responseData.request_uuid
        trackBookNowSuccessAttempt(
          'Reserve Now Success',
          props.bikeID,
          responseData.request_uuid,
          responseData.request_pretty_id
        )
        trackProceedToCheckoutSuccess(
          props.bikeID,
          resID,
          props.bikeData.bike_year,
          props.bikeData.bike_make,
          props.bikeData.bike_model,
          props.bikeData.bike_location.location_city,
          props.bikeData.bike_location.location_region,
          currentUrl,
          props.bikeData.bike_images[0].bike_image_url,
          props.bikeData.bike_daily_price_cents / 100,
          props.bikeData.bike_owner_name ?? 'Owner name missing'
        )
        props.history.push('/payments/book/' + resID)
      })
      .catch(function (responseData) {
        trackBookNowFailedAttempt('Reserve Now Error', {
          motorcycle_id: props.bikeID,
          raw_error_data: responseData,
        })

        if (responseData.errorCode === 400) {
          let processingErrorMsg =
            'We are having connection issues. Please try again.'
          const errors = responseData.errorResponseData?.error_messages;
          if (errors && errors.length > 0) {
            switch (errors[0]) {
              case 'date-conflict':
                processingErrorMsg =
                  'This bike is not available on one or more of the dates you selected, please select different dates to proceed.';
                break;

              case 'same-day-rental-error':
                processingErrorMsg =
                  'Same-day rental is not allowed for this motorcycle.';
                break;
            }
          }
          setBookLoading(false)
          setProcessingError(true)
          setProcessingErrorMessage(processingErrorMsg)
          trackProceedToCheckoutError(
            props.bikeID,
            processingErrorMessage,
            props.bikeData.bike_year,
            props.bikeData.bike_make,
            props.bikeData.bike_model,
            props.bikeData.bike_location.location_city,
            props.bikeData.bike_location.location_region,
            currentUrl,
            props.bikeData.bike_images[0].bike_image_url,
            props.bikeData.bike_daily_price_cents / 100,
            props.bikeData.bike_owner_name ?? 'Owner name missing'
          )
        } else {
          let errorMessage
          if (!responseData.errorResponseData) {
            errorMessage =
              'Oops. Something went wrong. If you continue to experience issues, please contact us at info@twistedroad.com'
          } else {
            let errorMessage
            if (!responseData?.errorResponseData) {
              errorMessage =
                'Oops. Something went wrong. If you continue to experience issues, please contact us at info@twistedroad.com'
            } else {
              errorMessage = responseData.errorResponseData?.error_messages[0]
            }
            this.setState({
              bookLoading: false,
              processingError: true,
              processingErrorMessage: errorMessage,
            })
            trackProceedToCheckoutError(this.props.bikeID, errorMessage)
          }
          setBookLoading(false)
          setProcessingError(true)
          setProcessingErrorMessage(errorMessage)
        }
      })
  }

  const handleBookNow = (isAuth, openLoginModal) => {
    if (startDate == null || endDate == null) {
      setFocusedInput('startDate')
      setOpenMobileDates(true)
      return false
    }

    const userBirthDate = Cookies.get('userBirthDate')

    if (!isAuth) {
      openLoginModal(bookReservation)
      return false
    }

    if (
      userBirthDate == "undefined" || userBirthDate == "null" ||
      userBirthDate == '' || !userBirthDate
    ) {
      setOpenBirthDateModal(true)
      return false
    }
    bookReservation()
  }

  const calculateDaysTotal = (start, end) => {
    if (!start || !end) {
      return false
    }

    setSummaryLoading(true)
    const { timezone } = props

    if (end === null) {
      end = start
      setEndDate(start)
    }

    if (start !== null && end !== null) {
      setSummaryLoading(true)

      const formattedDates = formatDatesForAPI(
        startDate,
        endDate ? endDate : startDate,
        timezone
      )

      const birthDate = Cookies.get('userBirthDate')
      const tempPricingOptions = {
        motorcycle_pretty_id: props.bikeID,
        time_info: {
          start_at: formattedDates.start,
          end_at: formattedDates.end,
        },
      }

      if (birthDate != 'null') {
        tempPricingOptions.birthdate = birthDate
      }
      props.doPricing({
        onSuccess: (pricingInfo) => {
          setSummaryLoading(false)
          props.onPricingSuccess(
            {
              start_at: formattedDates.start,
              end_at: formattedDates.end,
            },
            pricingInfo
          )
        },
        onError: () => {
          setSummaryLoading(false)
        },
        pricingOptions: tempPricingOptions,
        pricingDescription: props.pricingDescription,
      })
    }
  }

  const checkTheStartDate = (thisDate) => {
    var moment = require('moment-timezone')
    let dayIsBlocked = false
    const currentDate = moment().format('MM/DD/YYY')

    if (isBeforeDay(thisDate, moment())) {
      dayIsBlocked = true
    }

    // Enure, both time values are in the same timezone before checking for same day rental
    if (isSameDay(thisDate.tz(props.bikeData.bike_timezone), moment.tz(props.bikeData.bike_timezone))) {
      dayIsBlocked = !props.sameDayAvailable
    }

    // Check if date of the week is unavailable
    if (props.bikeData.working_hours) {
      const bikeTimezone = props.bikeData.bike_timezone
      for (let i = 0; i < props.bikeData.working_hours.length; i++) {
        if (
          props.bikeData.working_hours[i].day === thisDate.format('dddd') &&
          props.bikeData.working_hours[i].holiday
        ) {
          dayIsBlocked = true
        }
        // If the start is today - make sure it is not too late to rent it.
        if (
          props.bikeData.same_day_available &&
          currentDate === thisDate.format('MM/DD/YYY')
        ) {
          if (props.bikeData.same_day_rental_notice_hours) {
            const bikeTime = moment(
              props.bikeData.working_hours[i].end_at,
              'HH:mm a'
            )
            const currentTime = moment()
              .local()
              .tz(bikeTimezone)
              .add(
                parseInt(props.bikeData.same_day_rental_notice_hours),
                'hour'
              )
              .format('HH:mm a')
            if (bikeTime < currentTime) {
              dayIsBlocked = true
            }
          }
        }
      }
    }
    // Check blacked out dates
    blackOutDates.forEach((item, id) => {
      let itemFormatted = moment(thisDate).format('YYYY-MM-DD')
      if (itemFormatted === item) {
        dayIsBlocked = true
      }
    })
    // Check dealer closed days
    props.closedDays.forEach((item, id) => {
      let itemFormatted = moment(new Date(thisDate)).format('dddd')
      if (itemFormatted === item) {
        dayIsBlocked = true
      }
    })

    return dayIsBlocked
  }

  const checkTheEndDate = (thisDate) => {
    var moment = require('moment-timezone')
    let dayIsBlocked = false
    const currentDate = moment().format('MM/DD/YYY')

    if (isBeforeDay(thisDate, moment())) {
      dayIsBlocked = true
    }

    if (isSameDay(thisDate, moment())) {
      dayIsBlocked = !props.sameDayAvailable
    }

    if (startDate && moment(startDate) > moment(thisDate)) {
      dayIsBlocked = true
    }

    // Check if date of the week is unavailable
    if (props.bikeData.working_hours) {
      const bikeTimezone = props.bikeData.bike_timezone
      for (let i = 0; i < props.bikeData.working_hours.length; i++) {
        if (
          props.bikeData.working_hours[i].day === thisDate.format('dddd') &&
          props.bikeData.working_hours[i].holiday
        ) {
          dayIsBlocked = true
        }
        // If the start is today - make sure it is not too late to rent it.
        if (
          props.bikeData.same_day_available &&
          currentDate === thisDate.format('MM/DD/YYY')
        ) {
          if (props.bikeData.same_day_rental_notice_hours) {
            const bikeTime = moment(
              props.bikeData.working_hours[i].end_at,
              'HH:mm a'
            )
            const currentTime = moment()
              .local()
              .tz(bikeTimezone)
              .add(
                parseInt(props.bikeData.same_day_rental_notice_hours),
                'hour'
              )
              .format('HH:mm a')
            if (bikeTime < currentTime) {
              dayIsBlocked = true
            }
          }
        }
      }
    }
    // Check blacked out dates
    blackOutDates.forEach((item, id) => {
      let itemFormatted = moment(thisDate).format('YYYY-MM-DD')
      if (itemFormatted === item) {
        dayIsBlocked = true
      }
    })
    // Check dealer closed days
    props.closedDays.forEach((item, id) => {
      let itemFormatted = moment(new Date(thisDate)).format('dddd')
      if (itemFormatted === item) {
        dayIsBlocked = true
      }
    })

    return dayIsBlocked
  }

  const handleOpenMobileBook = () => {
    setMobileOpenState(true)
  }

  const handleCloseMobileBook = () => {
    setMobileOpenState(false)
  }

  const checkTiming = () => {
    if (startTime && endTime) {
      if (parseInt(endTime) <= parseInt(startTime) && !displayDateError) {
        setDisplayTimeError(true)
      } else {
        setDisplayTimeError(false)
      }
    }
  }

  const checkPricing = () => {
    const birthDate = Cookies.get('userBirthDate')
    const tempPricingOptions = {
      motorcycle_pretty_id: props.bikeID,
      time_info: prepStartAndEndTimeForBackend({
        start_time: startTime,
        end_time: endTime,
        start_date: startDate
          ? moment
            .tz(
              startDate.startOf('day').format('YYYY-MM-DD'),
              props.timezone
            )
            .utc()
          : null,
        end_date: endDate
          ? moment
            .tz(endDate.startOf('day').format('YYYY-MM-DD'), props.timezone)
            .utc()
          : null,
        timezone: props.timezone,
      }),
      delivery_latitude: deliveryApplied ? deliveryLat : null,
      delivery_longitude: deliveryApplied ? deliveryLong : null,
    }

    if (birthDate != 'null') {
      tempPricingOptions.birthdate = birthDate
    }
    props.doPricing({
      onSuccess: (pricingInfo) => {
        setSummaryLoading(false)
        setApplyingDeliveryFee(false)
        setDeliveryApplied(true)
        setCancelingDelivery(false)
        props.onPricingSuccess(
          {
            start_at: startTime,
            end_at: endTime,
          },
          pricingInfo
        )
      },
      onError: () => {
        setSummaryLoading(false)
      },
      pricingOptions: tempPricingOptions,
      pricingDescription: 'Pricing from Bike Profile Page',
    })
  }

  const augmentStartTimeOptions = () => {
    let startStartAt
    let startEndAt
    let motorcycleData = bikeData
    let isStartToday =
      moment(startDate).format('MM/DD/YYYY') === moment().format('MM/DD/YYYY')

    const startTimeList = props.bikeData.pickup_timings
      ? props.bikeData.pickup_timings
      : timeOptions
    let timeOptionsClone = JSON.parse(JSON.stringify(startTimeList))
    if (motorcycleData) {
      if (!isStartToday) {
        let startDateDayOfTheWeek = moment(startDate).format('dddd')
        if (motorcycleData.working_hours?.length > 0) {
          for (let i = 0; i < motorcycleData.working_hours.length; i++) {
            if (motorcycleData.working_hours[i].day === startDateDayOfTheWeek) {
              startStartAt = motorcycleData.working_hours[i].start_at
              startEndAt = motorcycleData.working_hours[i].end_at

              var start = startTimeList.findIndex(
                (x) => x.text === startStartAt
              )
              var timeOptionsLength = timeOptionsClone.length
              if (start === -1) {
                start = 0
              }
              timeOptionsClone = timeOptionsClone.slice(
                start,
                timeOptionsLength
              )
              timeOptionsLength = timeOptionsClone.length
              var end = timeOptionsClone.findIndex((x) => x.text === startEndAt)
              if (end === -1) {
                end = 0
              }
              timeOptionsClone = timeOptionsClone.slice(0, end + 1)
            }
          }
          return timeOptionsClone
        }
        if (motorcycleData.partner_hours?.length > 0) {
          for (let i = 0; i < motorcycleData.partner_hours.length; i++) {
            if (motorcycleData.partner_hours[i].day === startDateDayOfTheWeek) {
              startStartAt = motorcycleData.partner_hours[i].start_at
              startEndAt = motorcycleData.partner_hours[i].end_at

              var start = startTimeList.findIndex(
                (x) => x.text === startStartAt
              )
              var timeOptionsLength = timeOptionsClone.length
              if (start === -1) {
                start = 0
              }
              timeOptionsClone = timeOptionsClone.slice(
                start,
                timeOptionsLength
              )
              timeOptionsLength = timeOptionsClone.length
              var end = timeOptionsClone.findIndex((x) => x.text === startEndAt)
              if (end === -1) {
                end = 0
              }
              timeOptionsClone = timeOptionsClone.slice(0, end + 1)
            }
          }
          return timeOptionsClone
        }
        return startTimeList
      } else {
        let nextHour = null
        if (
          (parseInt(motorcycleData?.same_day_rental_notice_hours) > 0 ||
            parseInt(motorcycleData?.same_day_rental_notice_hours) === 0) &&
          isStartToday
        ) {
          nextHour = moment()
            .tz(props.timezone)
            .add(
              parseInt(motorcycleData.same_day_rental_notice_hours) + 1,
              'hour'
            )
            .format('H')
        } else {
          nextHour = moment()
            .tz(props.timezone)
            .add(1, 'hour')
            .format('H')
        }

        let startDateDayOfTheWeek = moment(startDate)
          .tz(props.timezone)
          .format('dddd')

        var start = startTimeList.findIndex((x) => x.key === nextHour)
        var timeOptionsLength = timeOptionsClone.length
        if (start === -1) {
          start = 0
        }
        timeOptionsClone = timeOptionsClone.slice(start, timeOptionsLength)
        if (motorcycleData.working_hours.length > 0) {
          for (let i = 0; i < motorcycleData.working_hours.length; i++) {
            if (motorcycleData.working_hours[i].day === startDateDayOfTheWeek) {
              startStartAt = motorcycleData.working_hours[i].start_at
              startEndAt = motorcycleData.working_hours[i].end_at
              var end = timeOptionsClone.findIndex((x) => x.text === startEndAt)
              if (end === -1) {
                end = 0
              }
              timeOptionsClone = timeOptionsClone.slice(0, end + 1)
            }
            return timeOptionsClone
          }
        } else {
          return timeOptionsClone
        }
      }
      return timeOptionsClone.slice(start, timeOptionsLength)
    }
  }

  const augmentEndTimeOptions = () => {
    let startStartAt
    let startEndAt
    let motorcycleData = bikeData
    let timezone = props.timezone
    const endTimeList = props.bikeData.dropoff_timings
      ? props.bikeData.dropoff_timings
      : timeOptions

    let endDateDayOfTheWeek = moment(endDate).format('dddd')
    let timeOptionsClone = JSON.parse(JSON.stringify(endTimeList))

    if (motorcycleData) {
      if (motorcycleData.working_hours?.length > 0) {
        for (let i = 0; i < motorcycleData.working_hours.length; i++) {
          if (motorcycleData.working_hours[i].day === endDateDayOfTheWeek) {
            startStartAt = motorcycleData.working_hours[i].start_at
            startEndAt = motorcycleData.working_hours[i].end_at

            var start = endTimeList.findIndex((x) => x.text === startStartAt)

            var timeOptionsLength = timeOptionsClone.length
            if (start === -1) {
              start = 0
            }
            timeOptionsClone = timeOptionsClone.slice(start, timeOptionsLength)
            timeOptionsLength = timeOptionsClone.length
            var end = timeOptionsClone.findIndex((x) => x.text === startEndAt)
            if (end === -1) {
              end = 0
            }
            timeOptionsClone = timeOptionsClone.slice(0, end + 1)
          }
        }
        return timeOptionsClone
      }
      if (motorcycleData.partner_hours?.length > 0) {
        for (let i = 0; i < motorcycleData.partner_hours.length; i++) {
          if (motorcycleData.partner_hours[i].day === endDateDayOfTheWeek) {
            startStartAt = motorcycleData.partner_hours[i].start_at
            startEndAt = motorcycleData.partner_hours[i].end_at

            var start = endTimeList.findIndex((x) => x.text === startStartAt)

            var timeOptionsLength = timeOptionsClone.length
            if (start === -1) {
              start = 0
            }
            timeOptionsClone = timeOptionsClone.slice(start, timeOptionsLength)
            timeOptionsLength = timeOptionsClone.length
            var end = timeOptionsClone.findIndex((x) => x.text === startEndAt)
            if (end === -1) {
              end = 0
            }
            timeOptionsClone = timeOptionsClone.slice(0, end + 1)
          }
        }
        return timeOptionsClone
      }
    }
    return endTimeList
  }

  const selectDelivery = () => {
    if (!deliverySelected) {
      setDeliverySelected(true)
    }
  }

  const applyDelivery = () => {
    setApplyingDeliveryFee(true)
    setExpanded(false)
    setDeliveryApplied(true)
    setDeliveryApplyClicked(true)
    if (childRef && childRef.current) {
      childRef.current.clearAutocompleteValue()
    }
  }

  const clearDelivery = () => {
    setCancelingDelivery(true)
    setDeliverySelected(false)
    setDeliveryApplied(false)
    setDeliveryApplyClicked(false)
    setExpanded(false)
    setDeliveryPrice(null)
    setDeliveryAddress(null)
    setDeliveryAddressObject(null)
    setDeliveryLat(null)
    setDeliveryLong(null)
    if (childRef && childRef.current) {
      childRef.current.clearAutocompleteValue()
    }
  }

  const calculateDelivery = () => {
    setDeliveryApplied(false)
    // setDeliveryLat(null)
    // setDeliveryLong(null)
    setIsCalculating(true)
    const apiURL =
      'motorcycles/' +
      props.bikeID +
      '/calculate_delivery_fees?delivery_latitude=' +
      deliveryLat +
      '&delivery_longitude=' +
      deliveryLong
    apiProcess(
      apiURL,
      false,
      'get-price-of-delivery',
      'Calculate delivery total.'
    )
      .then(
        function (responseData) {
          setIsCalculating(false)
          if (!responseData) {
            setUnableToDeliverError(true)
            setDeliveryPrice(null)
          } else {
            setUnableToDeliverError(false)
            setDeliveryPrice(
              responseData?.delivery_fees_information?.delivery_fees_cents
            )
          }
        }.bind(this)
      )
      .catch((e) => {
        setUnableToDeliverError(true)
      })
  }

  const cleanUpAddress = () => {
    return deliveryAddress.substring(0, deliveryAddress.indexOf(','))
  }

  useEffect(() => {
    if (sameDayRental === true && startDate && endDate) {
      checkTiming()
    }
    checkPricing()

    // Rental duration validation
    checkRentalDurationError()
  }, [sameDayRental, startTime, endTime, startDate, endDate, deliveryApplied])

  useEffect(() => {
    setDisplayTimeError(false)
    setDisplayDateError(false)
    if (startDate && endDate) {
      if (moment(new Date(startDate)).isAfter(moment(new Date(endDate)))) {
        setDisplayDateError(true)
      }
      if (
        moment(new Date(startDate)).format('YYYY-MM-DD') ===
        moment(new Date(endDate)).format('YYYY-MM-DD')
      ) {
        setSameDayRental(true)
      } else {
        setSameDayRental(false)
      }
    }
  }, [startDate, endDate])

  const suggestionSelect = (result, lat, lng, text, details) => {
    setDeliveryLat(lat)
    setDeliveryLong(lng)
    setDeliveryAddress(details.placeName)
    setDeliveryAddressObject({
      formatted_address: details?.placeName ? details.placeName.replace(", United States", "") : "",
      full_address: details?.placeName
    })

  }

  const GetCrossedOutPrice = ({ baseRentalPriceCents, baseRentalPriceCurrency }) => {
    return (
      <span className="mobile-multiday-cross-out is-inline-block mr-1">
        <NumberFormat
          defaultValue={convertCents(baseRentalPriceCents)}
          decimalScale={0}
          displayType={'text'}
          thousandSeparator={true}
          prefix={getSymbolFromCurrency(baseRentalPriceCurrency)}
        />
        /day
      </span>
    )
  }

  const processUserBirthDate = (birthDate) => {
    let apiURL = 'users/basic_info'

    let profileData = {
      contact: {
        birthdate: birthDate,
      },
    }

    apiProcess(
      apiURL,
      profileData,
      'update-profile',
      'Update Profile - Rider Contact Update'
    )
      .then(function(responseData) {})
      .catch(function(responseData) {
          console.log('Failed to update user profile', responseData)
        }
      )
  }

  const renderPickUpDayContents = (day) => {
    if (!endDate) return <div>{day.date()}</div>

    const rentalDuration = endDate.diff(day, 'days')
    let tooltip = null

    if (typeof minRentalDays === 'number' && rentalDuration > 0 && rentalDuration < minRentalDays) {
      tooltip = `${minRentalDays} day minimum rental duration`
    } else if (typeof maxRentalDays === 'number' && rentalDuration > maxRentalDays) {
      tooltip = ` ${maxRentalDays} day maximum rental duration`
    }

    return (
      <Tippy content={tooltip} disabled={!tooltip}>
        <div>{day.date()}</div>
      </Tippy>
    )
  }

  const renderDropOffDayContents = (day) => {
    if (!startDate) return <div>{day.date()}</div>

    const rentalDuration = day.diff(startDate, 'days')
    let tooltip = null

    if (typeof minRentalDays === 'number' && rentalDuration > 0 && rentalDuration < minRentalDays) {
      tooltip = `${minRentalDays} day minimum rental duration`
    } else if (typeof maxRentalDays === 'number' && rentalDuration > maxRentalDays) {
      tooltip = ` ${maxRentalDays} day maximum rental duration`
    }

    return (
      <Tippy content={tooltip} disabled={!tooltip}>
        <div>{day.date()}</div>
      </Tippy>
    )
  }

  const checkRentalDurationError = () => {
    if (!startDate || !startTime || !endDate || !endTime) {
      setRentalDurationError(null)
      return
    }

    const start = moment(`${startDate.format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm')
    const end = moment(`${endDate.format('YYYY-MM-DD')} ${endTime}`, 'YYYY-MM-DD HH:mm')

    // For maxRentalDays, use actual hour diff
    const durationHours = end.diff(start, 'hours', true);

    //for minRentalDays
    // Count any part of a day as a full day
    const rentalDays = Math.ceil(durationHours / 24)

    const hasMin = typeof minRentalHours === 'number'
    const hasMax = typeof maxRentalHours === 'number'

    if (hasMin && rentalDays < minRentalDays) {
      setRentalDurationError('tooShort')
    } else if (hasMax && rentalDays > maxRentalDays) {
      setRentalDurationError('tooLong')
    } else {
      setRentalDurationError(null)
    }
  }

  return (
    <>
      {desktopOrMobile === 'desktop' && (
        <>
          {openBirthDateModal &&
            <BirthDateModal
              openBirthDateModal={openBirthDateModal}
              onModalClose={(birthDate) => {
                setOpenBirthDateModal(false)
                setUserBirthDate(birthDate)
                processUserBirthDate(birthDate)
              }}
              style={{ overflow: 'visible' }}
            />
          }
          {
            <BookingCalendarTabs
              bikeData={bikeData}
              paymenModuleHeader={
                <BikeProfilePaymentModuleHeader
                  addClassName={
                    bikeData.for_sale ? 'bike-forSale' : 'bike-not-forSale'
                  }
                  multidayDiscountApplied={multidayDiscountApplied}
                  baseRentalPriceCents={baseRentalPriceCents}
                  baseRentalPriceCurrency={baseRentalPriceCurrency}
                  dailyPriceCents={bikeData.bike_daily_price_cents}
                  dailyPriceCurrency={bikeData.bike_daily_price_currency}
                  isAuthenticated={isAuthenticated}
                  startDate={startDate}
                  endDate={endDate}
                  bikeData={bikeData}
                  isTripTaken={isTripTaken}
                  multiDayPricingList={multiDayPricingLists}
                />
              }
              pickdropTiming={
                <>
                  <Formik>
                    <div className="bike-profile-time">
                      <div className="calendar-header">Pick Up</div>
                      <Columns
                        className={
                          displayTimeError || displayDateError
                            ? 'no-padding1 red-border'
                            : 'no-padding1'
                        }
                      >
                        <Columns.Column size={6} mobile={{ size: 6 }}>
                          <div {...tooltipProps}>
                            <div className="date-label">
                              <i className="fas fa-calendar-alt"></i>
                              &nbsp;<span>Pick Up Date</span>
                            </div>
                            <SingleDatePicker
                              placeholder="MM/DD/YYYY"
                              date={startDate}
                              onDateChange={(singleStartDate) => {
                                handleSingleDateChange(singleStartDate, null)
                              }}
                              focused={startDateFocus}
                              onFocusChange={({ focused }) => {
                                setStartDateFocus(focused)
                              }}
                              id="startDate"
                              isOutsideRange={checkTheStartDate}
                              renderDayContents={renderPickUpDayContents}
                            />
                          </div>
                        </Columns.Column>
                        <Columns.Column size={6} className="pick-up-time">
                          <Field
                            label={
                              <>
                                <i className="fas ffas fa-map-pin"></i>
                                &nbsp;<span>Pick Up Time</span>
                              </>
                            }
                            id="startAt"
                            name="startAt"
                            placeholder="Choose"
                            fullwidth
                            type="select"
                            disabled={startDate ? false : true}
                            value={startTime}
                            options={augmentStartTimeOptions()}
                            onChange={({ value }) => {
                              setStartTime(value)
                              setSummaryLoading(true)
                            }}
                          />
                        </Columns.Column>
                      </Columns>
                      <div className="calendar-header">Drop Off</div>
                      <Columns
                        className={
                          displayTimeError || displayDateError
                            ? 'no-padding2 red-border'
                            : 'no-padding2'
                        }
                      >
                        <Columns.Column size={6} mobile={{ size: 6 }}>
                          <div>
                            <div className="date-label">
                              <i className="fas fa-calendar-alt"></i>
                              &nbsp;<span>Drop Off Date</span>
                            </div>
                            <SingleDatePicker
                              placeholder="MM/DD/YYYY"
                              date={endDate}
                              onDateChange={(singleEndDate) => {
                                handleSingleDateChange(null, singleEndDate)
                              }}
                              focused={endDateFocus}
                              onFocusChange={({ focused }) => {
                                setEndDateFocus(focused)
                              }}
                              id="endDate"
                              isOutsideRange={checkTheEndDate}
                              renderDayContents={renderDropOffDayContents}
                            />
                          </div>
                        </Columns.Column>
                        <Columns.Column size={6} className="pick-up-time">
                          <Field
                            label={
                              <>
                                <i className="fas fa-map-pin"></i>
                                &nbsp;<span>Drop Off Time</span>
                              </>
                            }
                            id="endAt"
                            name="endAt"
                            placeholder="Choose"
                            fullwidth
                            type="select"
                            disabled={endDate ? false : true}
                            value={endTime}
                            options={augmentEndTimeOptions()}
                            onChange={({ value }) => {
                              setEndTime(value)
                              setSummaryLoading(true)
                            }}
                          />
                        </Columns.Column>
                      </Columns>
                      {displayTimeError && !displayDateError && !rentalDurationError && (
                        <div className="same-day-time-error">
                          For a one-day rental, the Pick Up time must be before
                          the Drop Off time. Please adjust your pick up and drop
                          off times.
                        </div>
                      )}
                      {displayDateError && !displayTimeError && (
                        <div className="same-day-time-error">
                          The Pick Up date must be before the Drop Off date.
                          Please adjust your pick up and drop off dates.
                        </div>
                      )}
                      {rentalDurationError &&
                        <RentalDurationError
                          rentalDurationError={rentalDurationError}
                          startDate={startDate}
                          minRentalHours={minRentalHours}
                          maxRentalHours={maxRentalHours}
                          startTime={startTime}
                          minRentalDays={minRentalDays}
                        />
                      }
                    </div>
                  </Formik>
                </>
              }
              locationOfDelivery={
                props.bikeData?.can_deliver ? (
                  <div className="bike-location-delivery">
                    <div className="delivery-header">Location & Delivery</div>
                    <Accordion
                      expanded={expanded}
                      sx={{
                        '&:before': {
                          display: 'none',
                        },
                      }}
                      style={{
                        border: '2px solid #e7e7e9',
                        borderRadius: '8px',
                        boxShadow: 'none',
                      }}
                    >
                      <AccordionSummary
                        onClick={() => {
                          setExpanded(!expanded)
                          if (!expanded) {
                            window.scrollTo(0, 750)
                          }
                          props.toggleFixedClass(!expanded)
                        }}
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              fontSize: '1.65rem',
                              color: '#695626 !important',
                            }}
                          />
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        {!deliveryAddress && (
                          <Typography className="delivery-accordion-header">
                            <i className="far fa-bolt bolt-custom-icon delivery-icon"></i>
                            {props.bikeData?.bike_location.location_city},{' '}
                            {props.bikeData?.bike_location.location_region_abbr}
                            <span className="delivery-label">Free</span>
                          </Typography>
                        )}
                        {deliveryAddress && deliveryPrice && deliveryApplied && (
                          <Typography className="delivery-accordion-header">
                            <i className="far fa-bolt bolt-custom-icon delivery-icon"></i>
                            {cleanUpAddress()}
                            <span className="delivery-label">
                              ${convertCents(deliveryPrice)}
                            </span>
                          </Typography>
                        )}
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="delivery-location-header-grey">
                          Pick Up At Bike Location
                        </div>
                        <div className="pick-up-instuctions">
                          We'll send you the exact address once your trip is
                          booked
                        </div>
                        <div
                          className={
                            !deliverySelected
                              ? 'delivery-details-container delivery-selected'
                              : 'delivery-details-container'
                          }
                          onClick={() => {
                            clearDelivery()
                          }}
                        >
                          <div className="delivery-location-header2">
                            <Grid container spacing={2}>
                              <Grid item>
                                <i class="fa-duotone fa-motorcycle delivery-icon"></i>
                              </Grid>
                              <Grid item xs={12} sm container>
                                <Grid
                                  item
                                  xs
                                  container
                                  direction="column"
                                  spacing={2}
                                >
                                  <Grid item xs>
                                    {
                                      props.bikeData?.bike_location
                                        .location_city
                                    }
                                    ,{' '}
                                    {
                                      props.bikeData?.bike_location
                                        .location_region_abbr
                                    }{' '}
                                    {
                                      props.bikeData?.bike_location
                                        .location_postal_code
                                    }
                                  </Grid>
                                  <Grid item xs>
                                    <div className="delivery-location-price">
                                      Free
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                        <div className="delivery-location-header-grey1">
                          Delivered To You
                        </div>
                        <div className="pick-up-instuctions">
                          This Owner delivers within a{' '}
                          {props.bikeData?.max_delivery_distance_in_miles} mile
                          radius at $
                          {
                            (Math.round(((props.bikeData?.price_per_mile_cents / 100) + Number.EPSILON) * 100) / 100).toFixed(2)
                          }
                          {' '}
                          a mile with a minimum fee of $
                          {(Math.round(((props.bikeData?.flat_delivery_fees_cents / 100) + Number.EPSILON) * 100) / 100).toFixed(2)}.
                        </div>
                        <div
                          className={
                            deliverySelected
                              ? 'delivery-details-container delivery-selected'
                              : 'delivery-details-container'
                          }
                          onClick={() => selectDelivery()}
                        >
                          <Grid container spacing={2}>
                            <Grid item>
                              <i class="fa-duotone fa-location-dot delivery-icon"></i>
                            </Grid>
                            <Grid item xs={12} sm container>
                              <Grid
                                item
                                xs
                                container
                                direction="column"
                                spacing={2}
                              >
                                <Grid item xs>
                                  <div className="delivery-location-header2">
                                    Enter a delivery address
                                  </div>
                                </Grid>

                                {deliverySelected && (
                                  <>
                                    <div className="delivery-address-container">
                                      <Formik>
                                        <>
                                          <MapboxAutocomplete
                                            publicKey={MAPBOX_API_KEY}
                                            inputClass='input is-normal mb-0'
                                            onSuggestionSelect={suggestionSelect}
                                            resetSearch={false}
                                            placeholder={"Enter Delivery"}
                                            value={''}
                                            ref={inputRef}
                                            country="us"
                                            resetSearchInput={false}
                                            types={['address', 'poi']}
                                            searchResultsClass='address-search-results-container'
                                          />
                                          {unableToDeliverError && (
                                            <div className="delivery-error">
                                              Sorry, delivery to this location
                                              is unavailable.
                                            </div>
                                          )}
                                        </>
                                      </Formik>
                                    </div>
                                    {deliveryPrice && !deliveryApplyClicked && (
                                      <>
                                        <div className="delivery-location-price2">
                                          <strong>
                                            { }
                                            ${convertCents(deliveryPrice)}
                                          </strong>
                                        </div>
                                        <div className="delivery-location-price-desc">
                                          (Includes pick-up and drop-off)
                                        </div>
                                        <Button
                                          color="primary"
                                          className="delivery-calculate-button"
                                          loading={applyingDeliveryFee}
                                          onClick={() => applyDelivery()}
                                          size="medium"
                                          type="submit"
                                        >
                                          Apply
                                        </Button>
                                      </>
                                    )}
                                    {deliveryApplyClicked && (
                                      <>
                                        <Button
                                          color="primary"
                                          className="delivery-calculate-button"
                                          loading={cancelingDelivery}
                                          onClick={() => clearDelivery()}
                                          size="medium"
                                          type="submit"
                                        >
                                          Cancel
                                        </Button>
                                      </>
                                    )}
                                    {!deliveryPrice && (
                                      <Button
                                        color="primary"
                                        className="delivery-calculate-button"
                                        loading={isCalculating}
                                        disabled={!deliveryLong || !deliveryLat}
                                        onClick={() => calculateDelivery()}
                                        size="medium"
                                        type="submit"
                                      >
                                        Calculate
                                      </Button>
                                    )}
                                  </>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ) : null
              }
              pricingSummary={
                <>
                  {props.hasPricingInfo && !summaryLoading && (
                    <div className="mt-5">
                      <PricingSummary
                        pricingInfo={props.pricingInfo}
                        loading={props.pricingLoading}
                        hasPricingInfo={props.hasPricingInfo}
                        hasPricingError={props.pricingError}
                        shortSummary={true}
                        hideNoPricingMessage={true}
                        bikeData={bikeData}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  )}
                  {processingError && (
                    <div className="date-calender-error">
                      {processingErrorMessage}
                    </div>
                  )}
                </>
              }
              checkoutButton={
                <>
                  <Subscribe to={[AppContainer]}>
                    {(auth) => (
                      <Button
                        color="primary"
                        fullwidth
                        className="mt-2 has-text-weight-bold is-yellow-btn"
                        size="medium"
                        disabled={
                          summaryLoading ||
                          bookLoading ||
                          processingError ||
                          startTime === null ||
                          endTime === null ||
                          displayTimeError ||
                          rentalDurationError
                        }
                        loading={summaryLoading || bookLoading}
                        onClick={() =>
                          handleBookNow(auth.state.isAuth, auth.openLogin)
                        }
                      >
                        Proceed to Checkout
                      </Button>
                    )}
                  </Subscribe>
                  <div className="mt-3 mb-0 has-text-centered">
                    You will select from available add-ons and choose insurance
                    on the next page.
                  </div>
                  {bikeData.is_partner &&
                    bikeData.partner_type === 'dealer' && (
                      <div className="is-size-7 has-text-grey mt-3 mb-0 has-text-centered">
                        * this test ride fee reimburses the dealer for wear and
                        tear on the vehicle during your test ride
                      </div>
                    )}
                </>
              }
            />
          }
        </>
      )}

      {/* Mobile Module starts here  */}
      {desktopOrMobile === 'mobile' && (
        <>
          {openBirthDateModal &&
            <BirthDateModal
              openBirthDateModal={openBirthDateModal}
              onModalClose={(birthDate) => {
                setOpenBirthDateModal(false)
                setUserBirthDate(birthDate)
                processUserBirthDate(birthDate)
              }}
            />
          }
          <Columns breakpoint={'mobile'} className="is-vcentered">
            <Columns.Column
              mobile={{
                size: 7,
              }}
            >
              {summaryLoading && (
                <img
                  height="40px"
                  width="40px"
                  src={DotsLoaderDark}
                  alt="Price Loading"
                  style={{
                    display: 'block',
                    width: '40px',
                    height: 'auto',
                  }}
                />
              )}
              {!summaryLoading && (
                <div className="listing-mobile-cta-price is-size-6">
                  {isAuthenticated && isTripTaken && canShowCrossedDailyRentalPrice(
                    startDate,
                    endDate,
                    bikeData.bike_info.has_multiday,
                    multiDayPricingLists
                  ) && (
                    <GetCrossedOutPrice
                      baseRentalPriceCents={baseRentalPriceCents}
                      baseRentalPriceCurrency={baseRentalPriceCurrency}
                    />
                  )}
                  {isAuthenticated && !isTripTaken && (
                    <GetCrossedOutPrice
                      baseRentalPriceCents={baseRentalPriceCents}
                      baseRentalPriceCurrency={baseRentalPriceCurrency}
                   />
                  )}
                  {!isAuthenticated && (
                    <GetCrossedOutPrice
                      baseRentalPriceCents={baseRentalPriceCents}
                      baseRentalPriceCurrency={baseRentalPriceCurrency}
                    />
                  )}
                  <NumberFormat
                    value={convertCents(!isAuthenticated ?  findPriceForNonLoggedInUser(
                      bikeData.bike_info.day_price_cents, startDate, endDate
                    ) : findPriceForLoggedInUser(
                      bikeData.bike_info, startDate, endDate, multiDayPricingLists, isTripTaken
                    ))}
                    className="is-size-5 has-text-weight-bold"
                    displayType={'text'}
                    decimalScale={0}
                    thousandSeparator={true}
                    prefix={getSymbolFromCurrency(
                      bikeData.bike_daily_price_currency
                    )}
                  />
                  /day
                </div>
              )}
              <RatingStars
                rating={bikeData.bike_overall_rating}
                size="tiny"
                ratingCount={bikeData.bike_review_count}
                tripTotal={bikeData.trips_taken}
              />
            </Columns.Column>
            <Columns.Column
              mobile={{
                size: 5,
              }}
            >
              <Button
                fullwidth
                color="primary"
                size={'normal'}
                className="has-text-weight-bold is-yellow-btn"
                disabled={processingError}
                onClick={() => handleOpenMobileBook()}
              >
                {startDate ? 'Proceed to Checkout' : 'Select Dates'}
              </Button>
            </Columns.Column>
          </Columns>
          {mobileOpenState && (
            <Modal
              closeOnEsc={false}
              closeOnBlur={false}
              showClose={true}
              show={mobileOpenState}
              onClose={handleCloseMobileBook}
              mobileAnimation={'up'}
              noPadding={true}
              modalWithTabs={true}
            >
              {
                <BookingCalendarTabs
                  bikeData={bikeData}
                  paymenModuleHeader={
                    <BikeProfilePaymentModuleHeader
                      addClassName={
                        bikeData.for_sale ? 'bike-forSale' : 'bike-not-forSale'
                      }
                      multidayDiscountApplied={multidayDiscountApplied}
                      baseRentalPriceCents={baseRentalPriceCents}
                      baseRentalPriceCurrency={baseRentalPriceCurrency}
                      dailyPriceCents={bikeData.bike_daily_price_cents}
                      dailyPriceCurrency={bikeData.bike_daily_price_currency}
                      isAuthenticated={isAuthenticated}
                      startDate={startDate}
                      endDate={endDate}
                      bikeData={bikeData}
                      isTripTaken={isTripTaken}
                      multiDayPricingList={multiDayPricingLists}
                    />
                  }
                  pickdropTiming={
                    <>
                      <Formik>
                        <div className="payment-block pick-up-drop-off-selectors bike-profile-time">
                          <Columns>
                            <Columns.Column>
                              <div {...tooltipProps}>
                                <MobileDatesSelector
                                  onDatesChange={handleDateChange}
                                  onFocusChange={onFocusChange}
                                  focusedInput={focusedInput}
                                  startDate={startDate}
                                  endDate={endDate}
                                  onClose={calculateDaysTotal}
                                  onClearDates={onClearDates}
                                  forceOpen={openMobileDates}
                                  selectorType="arrowFluid"
                                  wrapID={'mobile-wrap-container'}
                                  additionalDateProps={{
                                    renderDayContents: (day, modifiers) =>
                                      paymentModuleContents(
                                        day,
                                        startDate,
                                        endDate,
                                        timezone,
                                        props.closedDays,
                                        props.blackOutDates,
                                        'mobile',
                                        'mobile-wrap-container'
                                      ),
                                    isOutsideRange: checkTheStartDate,
                                  }}
                                />
                              </div>
                            </Columns.Column>
                          </Columns>
                          <Columns
                            className={
                              displayTimeError || displayDateError
                                ? 'is-mobile no-padding red-border'
                                : 'is-mobile no-padding'
                            }
                          >
                            <Columns.Column
                              mobile={{ size: 6 }}
                              className="pick-up-time"
                            >
                              <Field
                                id="startAt"
                                name="startAt"
                                placeholder="Pick Up Time"
                                fullwidth
                                type="select"
                                disabled={startDate ? false : true}
                                label={
                                  <>
                                    <i className="fas fa-calendar-alt"></i>
                                    &nbsp;<span>Pick Up</span>
                                  </>
                                }
                                value={startTime}
                                options={augmentStartTimeOptions()}
                                onChange={({ value }) => {
                                  setStartTime(value)
                                  setSummaryLoading(true)
                                }}
                              />
                            </Columns.Column>
                            <Columns.Column mobile={{ size: 6 }}>
                              <Field
                                id="endAt"
                                name="endAt"
                                type="select"
                                disabled={endDate ? false : true}
                                placeholder="Drop Off Time"
                                fullwidth
                                label={
                                  <>
                                    <i className="fas fa-calendar-alt"></i>
                                    &nbsp;<span>Drop Off</span>
                                  </>
                                }
                                options={augmentEndTimeOptions()}
                                value={endTime}
                                onChange={({ value }) => {
                                  setEndTime(value)
                                  setSummaryLoading(true)
                                }}
                              />
                            </Columns.Column>
                          </Columns>
                          {displayTimeError && !displayDateError && !rentalDurationError && (
                            <div className="same-day-time-error">
                              For a one-day rental, the Pick Up time must be
                              before the Drop Off time. Please adjust your pick
                              up and drop off times.
                            </div>
                          )}
                          {displayDateError && !displayTimeError && (
                            <div className="same-day-time-error">
                              The Pick Up date must be before the Drop Off date.
                              Please adjust your pick up and drop off dates.
                            </div>
                          )}
                          {rentalDurationError &&
                            <RentalDurationError
                              rentalDurationError={rentalDurationError}
                              startDate={startDate}
                              minRentalHours={minRentalHours}
                              maxRentalHours={maxRentalHours}
                              startTime={startTime}
                              minRentalDays={minRentalDays}
                            />
                          }
                        </div>
                      </Formik>
                    </>
                  }
                  locationOfDelivery={
                    props.bikeData?.can_deliver ? (
                      <div className="bike-location-delivery">
                        <div className="delivery-header">
                          Location & Delivery
                        </div>
                        <Accordion
                          expanded={expanded}
                          sx={{
                            '&:before': {
                              display: 'none',
                            },
                          }}
                          style={{
                            border: '2px solid #e7e7e9',
                            borderRadius: '8px',
                            boxShadow: 'none',
                          }}
                        >
                          <AccordionSummary
                            onClick={() => {
                              setExpanded(!expanded)
                              if (!expanded) {
                                window.scrollTo(0, 750)
                              }
                              props.toggleFixedClass(!expanded)
                            }}
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '1.65rem',
                                  color: '#695626 !important',
                                }}
                              />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            {!deliveryAddress && (
                              <Typography className="delivery-accordion-header">
                                <i className="far fa-bolt bolt-custom-icon delivery-icon"></i>
                                {props.bikeData?.bike_location.location_city},{' '}
                                {
                                  props.bikeData?.bike_location
                                    .location_region_abbr
                                }
                                <span className="delivery-label">Free</span>
                              </Typography>
                            )}
                            {deliveryAddress &&
                              deliveryPrice &&
                              deliveryApplied && (
                                <Typography className="delivery-accordion-header">
                                  <i className="far fa-bolt bolt-custom-icon delivery-icon"></i>
                                  {cleanUpAddress()}
                                  <span className="delivery-label">
                                    ${convertCents(deliveryPrice)}
                                  </span>
                                </Typography>
                              )}
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="delivery-location-header-grey">
                              Pick Up At Bike Location
                            </div>
                            <div className="pick-up-instuctions">
                              We'll send you the exact address once your trip is
                              booked
                            </div>
                            <div
                              className={
                                !deliverySelected
                                  ? 'delivery-details-container delivery-selected'
                                  : 'delivery-details-container'
                              }
                              onClick={() => {
                                clearDelivery()
                              }}
                            >
                              <div className="delivery-location-header2">
                                <Grid container spacing={1}>
                                  <Grid item>
                                    <i class="fa-duotone fa-motorcycle delivery-icon"></i>
                                  </Grid>
                                  <Grid item xs={10} sm container>
                                    <Grid
                                      item
                                      xs
                                      container
                                      direction="column"
                                      spacing={2}
                                    >
                                      <Grid item xs>
                                        {
                                          props.bikeData?.bike_location
                                            .location_city
                                        }
                                        ,{' '}
                                        {
                                          props.bikeData?.bike_location
                                            .location_region_abbr
                                        }{' '}
                                        {
                                          props.bikeData?.bike_location
                                            .location_postal_code
                                        }
                                      </Grid>
                                      <Grid item xs>
                                        <div className="delivery-location-price">
                                          Free
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                            <div className="delivery-location-header-grey1">
                              Delivered To You
                            </div>
                            <div className="pick-up-instuctions">
                              This Owner delivers within a{' '}
                              {props.bikeData?.max_delivery_distance_in_miles}{' '}
                              mile radius at $
                              {
                                (Math.round(((props.bikeData?.price_per_mile_cents / 100) + Number.EPSILON) * 100) / 100).toFixed(2)
                              }
                              {' '}
                              a mile with a minimum fee of $
                              {(Math.round(((props.bikeData?.flat_delivery_fees_cents / 100) + Number.EPSILON) * 100) / 100).toFixed(2)}.
                            </div>
                            <div
                              className={
                                deliverySelected
                                  ? 'delivery-details-container delivery-selected'
                                  : 'delivery-details-container'
                              }
                              onClick={() => selectDelivery()}
                            >
                              <Grid container spacing={1}>
                                <Grid item>
                                  <i class="fa-duotone fa-location-dot delivery-icon"></i>
                                </Grid>
                                <Grid item xs={10} sm container>
                                  <Grid
                                    item
                                    xs
                                    container
                                    direction="column"
                                    spacing={2}
                                  >
                                    <Grid item xs>
                                      <div className="delivery-location-header2">
                                        Enter a delivery address
                                      </div>
                                    </Grid>

                                    {deliverySelected && (
                                      <>
                                        <div className="delivery-address-container">
                                          <Formik>
                                            <>
                                              <MapboxAutocomplete
                                                publicKey={MAPBOX_API_KEY}
                                                inputClass='input is-normal mb-0'
                                                onSuggestionSelect={suggestionSelect}
                                                resetSearch={false}
                                                placeholder={"Enter Delivery"}
                                                value={''}
                                                ref={inputRef}
                                                country="us"
                                                resetSearchInput={false}
                                                types={['address', 'poi']}
                                                searchResultsClass='address-search-results-container'
                                              />
                                              {unableToDeliverError && (
                                                <div className="delivery-error">
                                                  Sorry, delivery to this
                                                  location is unavailable.
                                                </div>
                                              )}
                                            </>
                                          </Formik>
                                        </div>
                                        {deliveryPrice && !deliveryApplyClicked && (
                                          <>
                                            <div className="delivery-location-price2">
                                              <strong>
                                                ${convertCents(deliveryPrice)}
                                              </strong>
                                            </div>
                                            <div className="delivery-location-price-desc">
                                              (Includes pick-up and drop-off)
                                            </div>
                                            <Button
                                              color="primary"
                                              className="delivery-calculate-button"
                                              loading={applyingDeliveryFee}
                                              onClick={() => applyDelivery()}
                                              size="medium"
                                              type="submit"
                                            >
                                              Apply
                                            </Button>
                                          </>
                                        )}
                                        {deliveryApplyClicked && (
                                          <>
                                            <Button
                                              color="primary"
                                              className="delivery-calculate-button"
                                              loading={cancelingDelivery}
                                              onClick={() => clearDelivery()}
                                              size="medium"
                                              type="submit"
                                            >
                                              Cancel
                                            </Button>
                                          </>
                                        )}
                                        {!deliveryPrice && (
                                          <Button
                                            color="primary"
                                            className="delivery-calculate-button"
                                            loading={isCalculating}
                                            disabled={
                                              !deliveryLong || !deliveryLat
                                            }
                                            onClick={() => calculateDelivery()}
                                            size="medium"
                                            type="submit"
                                          >
                                            Calculate
                                          </Button>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ) : null
                  }
                  pricingSummary={
                    <>
                      {props.hasPricingInfo && !summaryLoading && (
                        <div className="mt-5">
                          <PricingSummary
                            pricingInfo={props.pricingInfo}
                            loading={props.pricingLoading}
                            hasPricingInfo={props.hasPricingInfo}
                            hasPricingError={props.pricingError}
                            shortSummary={true}
                            hideNoPricingMessage={true}
                            bikeData={bikeData}
                            startDate={startDate}
                            endDate={endDate}
                          />
                        </div>
                      )}
                      {processingError && (
                        <div className="date-calender-error">
                          {processingErrorMessage}
                        </div>
                      )}
                    </>
                  }
                  checkoutButton={
                    <>
                      <Subscribe to={[AppContainer]}>
                        {(auth) => (
                          <Button
                            color="primary"
                            fullwidth
                            className="mt-2 has-text-weight-bold is-yellow-btn"
                            size="large"
                            disabled={
                              summaryLoading ||
                              bookLoading ||
                              processingError ||
                              startTime === null ||
                              endTime === null ||
                              displayTimeError
                            }
                            loading={summaryLoading || bookLoading}
                            onClick={() =>
                              handleBookNow(auth.state.isAuth, auth.openLogin)
                            }
                          >
                            Proceed to Checkout
                          </Button>
                        )}
                      </Subscribe>
                      <div className="mt-3 mb-0 has-text-centered">
                        You will select from available add-ons and choose
                        insurance on the next page.
                      </div>
                      {bikeData.is_partner &&
                        bikeData.partner_type === 'dealer' && (
                          <div className="is-size-7 has-text-grey mt-3 mb-0 has-text-centered">
                            * this test ride fee reimburses the dealer for wear
                            and tear on the vehicle during your test ride
                          </div>
                        )}
                    </>
                  }
                />
              }
            </Modal>
          )}
        </>
      )}
      {/* Mobile Module ends here  */}
    </>
  )
}

export default compose(
  withRouter,
  withGetPricing
)(MotorcycleBookingWCalendarPanel)

MotorcycleBookingWCalendarPanel.defaultProps = {
  startDate: null,
  endDate: null,
  timezone: null,
  onDateChange: function () { },
  toggleFixedClass: function () { },
  blackOutDates: [],
  desktopOrMobile: 'desktop',
  processingDescription: 'Missing Description',
  pricingDescription: 'Missing Description',
  onPricingSuccess: function () { },
  onBookingSuccess: function () { },
  redirectOnSuccess: true,
  sameDayAvailable: false,
  closedDays: [],
  onClearDates: function () { },
}
